const e = (d) => d && ["lg", "md", "sm"].includes(d);
export {
  e as validateFormSize
};
